import AddEvent from './addScheduleSession';
import CopyEvent from './copyEvent';
import DeleteEvent from './deleteEvent';
import InfoEvent from './InfoEvent';
import AddInstantSession from './addInstantSession';
import AddDiscretionaryHours from './addDiscretionaryHours';
import EditDiscretionaryHours from './editDiscretionaryHours';
import InfoDiscretionaryHours from './InfoDiscretionaryHours';
import Filters from '../CalendarHeader/filters';

const CalendarPopups = () => (
	<>
		<AddEvent />
		<CopyEvent />
		<DeleteEvent />
		<InfoEvent />
		<AddInstantSession />
		<AddDiscretionaryHours />
		<EditDiscretionaryHours />
		<InfoDiscretionaryHours />
		<Filters />
	</>
);

export default CalendarPopups;
